import { MapDirectionsService, MapGeocoder } from "@angular/google-maps";
import { GeneratorDto, JobDto, RefuelRuleDto, UserDto, WageListDto } from "app/api/models";
import { SettingsService } from "app/api/services";
import { sumList } from "app/app.component";
import { TimeUtil } from "app/core/utils/time-utils";

export class JobUtils {

    public static generateWage(startDate: Date, endDate: Date, driver: UserDto, ref: string, jobId: number) {
        // Rate A - Mon - fri (6am - 6pm)
        // Rate B - Other hours
        console.log("start date, end date", startDate, endDate);

        var totalHours = TimeUtil.getHoursBetween(startDate, endDate);

        console.log("total hours", totalHours);

        var hoursAStart = TimeUtil.setTo1amUTC(new Date(startDate));
        hoursAStart.setHours(6);
        var hoursAEnd = TimeUtil.setTo1amUTC(new Date(startDate));
        hoursAEnd.setHours(18);
        var hoursA = TimeUtil.getHoursOfOverlap(startDate, endDate, hoursAStart, hoursAEnd);
        var hoursB = totalHours - hoursA;

        console.log("hoursAstart, hoursAend", hoursAStart, hoursAEnd);

        var pay = hoursA * driver?.hourlyRateA + hoursB * driver?.hourlyRateB;
        var additions = 0;

        var wage = <WageListDto> {
            dateCreated: new Date().toISOString(),
            driverId: driver.id,
            hoursA: hoursA,
            hoursB: hoursB,
            reference: ref, //'auto-complete-job', //get new number
            fares: pay,
            additions: additions,
            total: pay + additions,
            jobId: jobId,
            // status?: WageStatusDto;
        }

        return wage;
    }

    public static getJobDialogData(isLastJob: boolean) {
        var items: any[] = [
            {name: 'hours', mandatory: true, type: 'number'},
        ]

        if(isLastJob)
            items.push({name: 'Return Location', mandatory: true, propertyName: 'location', locationButton: true });

        return {
            panelClass: 'max-width-item-dialog',
            data: {
                title: "Finish Job",
                items: items,
            }
        };
    }

    public static openLocation(location: string) {
        if(!location) return;

        window.open("http://maps.apple.com/maps?q=" + location); //todo sanitize it??
    }

    
    public static async getGoogleRoute(loc1: string, loc2: string, geocoder: MapGeocoder, directions: MapDirectionsService): Promise<google.maps.DirectionsRoute[]> {
        if(!loc1 || !loc2) return null;

        var res1 = await geocoder.geocode({address: loc1}).toPromise();
        if(!res1.status || !res1.results?.length) return;

        var coords1 = res1.results[0].geometry.location;

        var res2 = await geocoder.geocode({address: loc2}).toPromise();
        if(!res2.status || !res2.results?.length) return;

        var coords2 = res2.results[0].geometry.location;

        var req: google.maps.DirectionsRequest = {
            travelMode: google.maps.TravelMode.DRIVING,
            origin: {
            lat: coords1.lat(),
            lng: coords1.lng(),
            },
            destination: {
            lat: coords2.lat(),
            lng: coords2.lng(),
            },
            provideRouteAlternatives: false,
        };

        console.log("route req", req);

        var res3 = await directions.route(req).toPromise();

        if(!res3.status || !res3.result) return;

        return res3.result.routes;
    }

    public static async calculateDuration(loc1: string, loc2: string, geocoder: MapGeocoder, directions: MapDirectionsService) {
        var routes = await JobUtils.getGoogleRoute(loc1, loc2, geocoder, directions);
        
        var duration = sumList(routes[0].legs.map(x => x.duration.value / 3600)); //seconds to hours

        return duration;
    }

    public static async calculateMileage(loc1: string, loc2: string, geocoder: MapGeocoder, directions: MapDirectionsService) {
        var routes = await JobUtils.getGoogleRoute(loc1, loc2, geocoder, directions);
        
        var distance = sumList(routes[0].legs.map(x => x.distance.value * 0.000621371)); //meters to miles

        return distance;
    }

    public static async generateRefuelJobs(job: JobDto, generator: GeneratorDto, refuelRules: RefuelRuleDto[]): Promise<JobDto[]> {
        console.log("generating refuels for", job, "generator", generator, "rules", refuelRules);
        var refuelJobs: JobDto[] = [];

        if (!generator) {
            console.warn("No generator found for genId:", job.genId);
            return refuelJobs;
        }

        var jobCopy = Object.assign({}, job);
        jobCopy.jobId = null;
        jobCopy.deliveryAddress = job.deliveryAddress;
        jobCopy.mileage = 0;
        jobCopy.accepted = false;
        jobCopy.declined = false;
        jobCopy.completed = false;
        jobCopy.requireForm = false;
        jobCopy.isPending = false;
        jobCopy.jobType = 'Refuel';

        var endDate = job.deliveryDate ? new Date(job.deliveryDate) : null;
        var baseRefuelTime = TimeUtil.addHours(TimeUtil.setTo1amUTC(new Date(job.collectionDate)), 7); // 8am
        var refuelI = 0;

        console.log("base refuel time", baseRefuelTime);

        // Find applicable refuel rules for this generator and sort by priority (highest first)
        var applicableRules = refuelRules
            .filter(rule => {
                // Check if rule applies to this generator based on conditions
                return rule.conditions?.some(condition => {
                    // Using conditionType enum and value1 property based on actual DTO structure
                    if (condition.conditionType === 0 && condition.value1 === generator.genId) return true; // GenId
                    if (condition.conditionType === 1 && condition.value1 === generator.vehicleType?.toString()) return true; // VehicleType
                    if (condition.conditionType === 2 && condition.value1 === generator.refuelScheduleType?.toString()) return true; // RefuelScheduleType
                    return false;
                });
            })
            .sort((a, b) => (b.priority || 0) - (a.priority || 0)); // Sort by priority descending

        console.log("applicable rules", applicableRules);

        // If no specific rules found, use schedule type from generator
        if (applicableRules.length === 0) {
            switch (generator.refuelScheduleType) {
                case 6: // 6 hour - AM/PM/Night (like old 200 series)
                    refuelJobs.push(...this.create6HourRefuels(jobCopy, baseRefuelTime, job.jobRef, refuelI));
                    break;
                case 8: // 8 hour - AM/PM (like old 200 series without night)
                    refuelJobs.push(...this.create8HourRefuels(jobCopy, baseRefuelTime, job.jobRef, refuelI));
                    break;
                case 12: // 12 hour - Day only
                    refuelJobs.push(...this.create12HourRefuels(jobCopy, baseRefuelTime, endDate, job.jobRef, refuelI));
                    break;
                case 24: // 24 hour - Day + Depot
                    refuelJobs.push(...this.create24HourRefuels(jobCopy, baseRefuelTime, endDate, job.jobRef, refuelI));
                    break;
                default:
                    console.log("No standard refuel schedule, using custom rules only");
                    break;
            }
        } else {
            // Apply custom rules
            for (const rule of applicableRules) {
                refuelJobs.push(...this.applyRefuelRule(rule, jobCopy, baseRefuelTime, endDate, job.jobRef, refuelI));
                refuelI += rule.actions?.length || 0;
            }
        }

        return refuelJobs;
    }

    private static create6HourRefuels(jobCopy: JobDto, baseTime: Date, jobRef: string, refuelI: number): JobDto[] {
        const jobs: JobDto[] = [];
        
        // AM refuel (8am)
        const amJob = Object.assign({}, jobCopy);
        amJob.collectionAddress = "AM Refuel";
        amJob.jobType = "AM Refuel";
        amJob.collectionDate = baseTime.toISOString();
        amJob.deliveryDate = baseTime.toISOString();
        amJob.jobRef = `${jobRef}-RF${++refuelI}`;
        jobs.push(amJob);

        // PM refuel (4pm)
        const pmTime = TimeUtil.addHours(new Date(baseTime), 8);
        const pmJob = Object.assign({}, jobCopy);
        pmJob.collectionAddress = "PM Refuel";
        pmJob.jobType = "PM Refuel";
        pmJob.collectionDate = pmTime.toISOString();
        pmJob.deliveryDate = pmTime.toISOString();
        pmJob.jobRef = `${jobRef}-RF${++refuelI}`;
        jobs.push(pmJob);

        // Night refuel (11pm)
        const nightTime = TimeUtil.setTo2359UTC(new Date(pmTime));
        const nightJob = Object.assign({}, jobCopy);
        nightJob.collectionAddress = "Night Refuel";
        nightJob.jobType = "Night Refuel";
        nightJob.collectionDate = nightTime.toISOString();
        nightJob.deliveryDate = nightTime.toISOString();
        nightJob.jobRef = `${jobRef}-RF${++refuelI}`;
        jobs.push(nightJob);

        return jobs;
    }

    private static create8HourRefuels(jobCopy: JobDto, baseTime: Date, jobRef: string, refuelI: number): JobDto[] {
        const jobs: JobDto[] = [];
        
        // AM refuel (8am)
        const amJob = Object.assign({}, jobCopy);
        amJob.collectionAddress = "AM Refuel";
        amJob.jobType = "AM Refuel";
        amJob.collectionDate = baseTime.toISOString();
        amJob.deliveryDate = baseTime.toISOString();
        amJob.jobRef = `${jobRef}-RF${++refuelI}`;
        jobs.push(amJob);

        // PM refuel (4pm)
        const pmTime = TimeUtil.addHours(new Date(baseTime), 8);
        const pmJob = Object.assign({}, jobCopy);
        pmJob.collectionAddress = "PM Refuel";
        pmJob.jobType = "PM Refuel";
        pmJob.collectionDate = pmTime.toISOString();
        pmJob.deliveryDate = pmTime.toISOString();
        pmJob.jobRef = `${jobRef}-RF${++refuelI}`;
        jobs.push(pmJob);

        return jobs;
    }

    private static create12HourRefuels(jobCopy: JobDto, baseTime: Date, endDate: Date, jobRef: string, refuelI: number): JobDto[] {
        const jobs: JobDto[] = [];
        
        // Day refuel
        const dayJob = Object.assign({}, jobCopy);
        dayJob.collectionAddress = "Day Refuel";
        dayJob.jobType = "Day Refuel";
        dayJob.collectionDate = baseTime.toISOString();
        dayJob.deliveryDate = baseTime.toISOString();
        dayJob.jobRef = `${jobRef}-RF${++refuelI}`;
        jobs.push(dayJob);

        return jobs;
    }

    private static create24HourRefuels(jobCopy: JobDto, baseTime: Date, endDate: Date, jobRef: string, refuelI: number): JobDto[] {
        const jobs: JobDto[] = [];
        
        // Day refuel
        const dayJob = Object.assign({}, jobCopy);
        dayJob.collectionAddress = "Day Refuel";
        dayJob.jobType = "Day Refuel";
        dayJob.collectionDate = baseTime.toISOString();
        dayJob.deliveryDate = baseTime.toISOString();
        dayJob.jobRef = `${jobRef}-RF${++refuelI}`;
        jobs.push(dayJob);
        
        if (endDate) {
            // Depot refuel
            const depotJob = Object.assign({}, jobCopy);
            depotJob.collectionAddress = "Depot Refuel";
            depotJob.jobType = "Depot Refuel";
            depotJob.collectionDate = endDate.toISOString();
            depotJob.deliveryDate = endDate.toISOString();
            depotJob.jobRef = `${jobRef}-RF${++refuelI}`;
            jobs.push(depotJob);
        }

        return jobs;
    }

    private static applyRefuelRule(rule: RefuelRuleDto, jobCopy: JobDto, baseTime: Date, endDate: Date, jobRef: string, refuelI: number): JobDto[] {
        const jobs: JobDto[] = [];
        
        if (!rule.actions) return jobs;

        for (const action of rule.actions) {
            const refuelJob = Object.assign({}, jobCopy);
            refuelJob.collectionAddress = action.refuelType || "Custom Refuel";
            refuelJob.jobType = action.refuelType || "Custom Refuel";
            
            // Calculate time based on action parameters
            let refuelTime = new Date(baseTime);
            if (action.scheduleOffset) {
                refuelTime = TimeUtil.addHours(refuelTime, action.scheduleOffset);
            }
            
            refuelJob.collectionDate = refuelTime.toISOString();
            refuelJob.deliveryDate = refuelTime.toISOString();
            refuelJob.jobRef = `${jobRef}-RF${++refuelI}`;
            jobs.push(refuelJob);
        }

        return jobs;
    }

}
